<template>
  <!-- 企业管理-创建企业 -->
      <div class="container">
          <div class="handle-box-search">
              <div class="handle-box">
                  <el-row class="head-search">
                      <span class="title">企业名称:</span>

                      <el-input
                          v-model="search_data.company_name "
                          placeholder="请输入企业名称"
                          class="handle-input mr10"
                          @keyup.enter.native="searchStoreLists"
                      ></el-input>
                  </el-row>
                  <el-row class="head-search">
                      <span class="title">申请人:</span>

                      <el-input
                          v-model="search_data.name "
                          placeholder="请输入申请人"
                          class="handle-input mr10"
                          @keyup.enter.native="searchStoreLists"
                      ></el-input>
                  </el-row>
                  <el-row class="head-search">
                      <span class="title">申请人电话:</span>

                      <el-input
                          v-model="search_data.phone"
                          placeholder="请输入申请人电话"
                          class="handle-input mr10"
                          maxlength="11"
                          @keyup.enter.native="searchStoreLists"
                      ></el-input>
                  </el-row>
              </div>

              <el-button type="primary" icon="el-icon-search" @click="searchStoreLists">搜索</el-button>

              <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
          </div>
          <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header" @row-click="rowContextmenu">
              <el-table-column label="企业名称" prop="company_name" min-width="130"> </el-table-column>

              <el-table-column label="企业人数" prop="company_num" min-width="100"> </el-table-column>

              <el-table-column label="城市名称" prop="city_name" min-width="180"> </el-table-column>

              <el-table-column label="申请人" prop="name" min-width="120"> </el-table-column>
              <el-table-column label="职务" prop="job" min-width="120"> </el-table-column>
              <el-table-column label="电话" prop="phone" min-width="120"> </el-table-column>
              <el-table-column label="时间" prop="time_stamp" min-width="180">
                <template slot-scope="scope">
                  {{ scope.row.time.YmdHis }}
                </template>
              </el-table-column>



              <el-table-column width="260" label="操作">
                  <template slot-scope="scope">
                      <el-button type="primary" v-if="scope.row.status!=1" @click.stop="editStoreStatus(scope.row.id)">通过</el-button>

                  </template>
              </el-table-column>
          </el-table>

          <!-- 分页组件 -->
          <div class="pagination">
              <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
          </div>

      </div>
  </template>

  <script>
  var _this;

  export default {
      components: {
         
      },
      data() {
          return {


              // 存放表格数据
              tableData: [],

              //翻页数据
              search_data: {
                  page: 1,
                  limit: 10,
                  name: ''
              },

              result_data: [],
              search_rules: {
                  page: {
                      placeholder: '页码',
                      rules: {
                          required: true,
                          message: '页码需要大于0',
                          regulation: 'gt',
                          rulesData: 0
                      }
                  },
                  limit: {
                      placeholder: '每页个数',
                      rules: {
                          required: true,
                          message: '每页个数需在1-51之内',
                          regulation: 'between',
                          rulesData: [1, 51]
                      }
                  }
              }
          };
      },
      created() {
          _this = this;

          _this.storeLists();
      },

      methods: {

        editStoreStatus(val) {
            _this
                .$post('/store/examineSubmit', { id: val })
                .then((res) => {
                    _this.$message.success(res.msg);
                    _this.storeLists();
                })
                .catch((err) => {});
        },


          searchStoreLists() {
              _this.search_data.page = 1;
              _this.storeLists();
          },

          // 搜索用户管理列表
          storeLists() {
              _this
                  .$post('/store/enterpriseCooperationList', _this.search_data, _this.search_rules)
                  .then((res) => {
                      // 将请求的数据存放到表格数据数组中
                      _this.tableData = res.data;
                      _this.result_data = res;
                  })
                  .catch((err) => {});
          },
          //翻页组件的回调
          pages_function(search_data) {
              //赋值
              _this.search_data = search_data;
              //初始化列表
              _this.storeLists();
          },

          // 刷新按钮
          refresh() {
              this.$router.go(0);
          }
      }
  };
  </script>

  <style scoped>
  .handle-box {
      margin-bottom: 20px;
  }

  .handle-select {
      width: 120px;
  }

  .handle-input {
      width: 200px;
      display: inline-block;
  }

  .table {
      width: 100%;
      font-size: 14px;
  }

  .red {
      color: #ff0000;
  }

  .mr10 {
      margin-right: 10px;
  }

  .table-td-thumb {
      display: block;
      margin: auto;
      width: 40px;
      height: 40px;
  }

  .el-table__row {
      height: 100px;
  }

  .el-dropdown {
      vertical-align: top;
  }

  .el-dropdown + .el-dropdown {
      margin-left: 15px;
  }

  .el-icon-arrow-down {
      font-size: 12px;
  }
  </style>
